import React, { useEffect, useMemo, useState } from 'react';
import logoIconPng from './logo-icon.svg';

const Icons = {
  Os: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="6" cy="15" r="4" />
      <circle cx="18" cy="15" r="4" />
      <path d="M10 15a2 2 0 0 1 4 0" />
      <path d="M2.5 13 5 7c.7-1.3 1.4-2 3-2" />
      <path d="M21.5 13 19 7c-.7-1.3-1.5-2-3-2" />
    </svg>
  ),
  Lens: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="7" />
      <path d="M5.5 14.5c2.8-1.5 6.1-1.7 9.2-.4 1.4.6 2.8.8 3.8.7" />
    </svg>
  ),
  Calendar: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),
  Building: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 21V5a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v16" />
      <path d="M17 9h1a2 2 0 0 1 2 2v10" />
      <path d="M8 7h5" />
      <path d="M8 11h5" />
      <path d="M8 15h5" />
      <path d="M3 21h18" />
    </svg>
  ),
  Users: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9.5" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  ChevronRight: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="9 18 15 12 9 6" />
    </svg>
  ),
  LogOut: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  )
};

const quickCards = [
  { title: 'Ordens de Serviço', description: 'Atendimentos, receitas e pagamentos.', href: '/ordens-servico', icon: <Icons.Os /> },
  { title: 'Cadastro de Lentes', description: 'Tabela de lentes e valores de venda.', href: '/produtos', icon: <Icons.Lens /> },
  { title: 'Agendamentos', description: 'Controle de compromissos e retornos.', href: '/agendamentos', icon: <Icons.Calendar /> }
];

const adminCards = [
  { title: 'Lojas e Empresas', description: 'Dados da empresa e configurações.', href: '/empresas', icon: <Icons.Building /> },
  { title: 'Equipe e Acessos', description: 'Usuários e permissões internas.', href: '/cadastro', icon: <Icons.Users /> }
];

function safeParse(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

function getFirstName(name) {
  return String(name || 'Usuário').trim().split(' ')[0] || 'Usuário';
}

function getInitials(name) {
  const parts = String(name || 'Lumix').trim().split(' ').filter(Boolean);
  if (!parts.length) return 'LX';
  const first = parts[0]?.[0] || 'L';
  const second = parts[1]?.[0] || parts[0]?.[1] || 'X';
  return `${first}${second}`.toUpperCase();
}

function formatDate() {
  const date = new Date();
  const formatted = new Intl.DateTimeFormat('pt-BR', { weekday: 'long', day: 'numeric', month: 'long' }).format(date);
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
}

export default function Home() {
  const [mounted, setMounted] = useState(false);
  const user = useMemo(() => {
    return safeParse('vizumUser', { nomeCompleto: 'Usuário', loja: 'Matriz', tipo: 'admin' });
  }, []);

  const firstName = useMemo(() => getFirstName(user.nomeCompleto), [user.nomeCompleto]);
  const initials = useMemo(() => getInitials(user.nomeCompleto), [user.nomeCompleto]);
  const today = useMemo(() => formatDate(), []);
  const isAdmin = user.tipo === 'admin';

  useEffect(() => {
    setMounted(true);
  }, []);

  function logout() {
    document.body.style.opacity = '0';
    setTimeout(() => {
      localStorage.clear();
      window.location.href = '/login';
    }, 240);
  }

  return (
    <div className="gm-layout-home">
      <style>{css}</style>

      {/* ── TOPBAR (Comporta-se diferente no Desktop e Mobile) ── */}
      <header className="gm-app-topbar">
        <div className="gm-topbar-inner">
          
          {/* VISÃO DESKTOP: Logo completa */}
          <a href="/home" className="gm-brand hide-mobile">
            <div className="gm-logo-wrapper">
              <img src={logoIconPng} alt="Lumix" />
            </div>
            <span className="gm-brand-text">
              Lumix <span style={{ color: '#1a73e8' }}>Ó</span>
              <span style={{ color: '#d93025' }}>t</span>
              <span style={{ color: '#fbbc04' }}>i</span>
              <span style={{ color: '#188038' }}>c</span>
              <span style={{ color: '#1a73e8' }}>a</span>
              <span style={{ color: '#d93025' }}>s</span>
            </span>
          </a>

          {/* VISÃO MOBILE: Logo completa + saudação */}
          <div className="gm-mobile-brand-user show-mobile">
            <a href="/home" className="gm-mobile-brand" aria-label="Lumix Óticas">
              <div className="gm-logo-wrapper gm-logo-mobile"><img src={logoIconPng} alt="Lumix" /></div>
              <span className="gm-brand-text gm-brand-text-mobile">
                Lumix <span style={{ color: '#1a73e8' }}>Ó</span>
                <span style={{ color: '#d93025' }}>t</span>
                <span style={{ color: '#fbbc04' }}>i</span>
                <span style={{ color: '#188038' }}>c</span>as
              </span>
            </a>
            <div className="gm-greeting-mobile"><span>Olá,</span><strong>{firstName}</strong></div>
          </div>

          <div className="gm-topbar-actions">
            {/* Infos e Avatar do Desktop */}
            <div className="gm-user-meta hide-mobile">
              <strong>{firstName}</strong>
              <span>{user.loja || 'Matriz'}</span>
            </div>
            <div className="gm-avatar hide-mobile" title={user.nomeCompleto}>{initials}</div>

            <button type="button" className="gm-btn-logout" onClick={logout} title="Sair do sistema">
              <Icons.LogOut />
              <span className="hide-mobile">Sair</span>
            </button>
          </div>
        </div>
      </header>

      {/* ── MAIN CONTENT ── */}
      <main className={`gm-main-content ${mounted ? 'ready' : ''}`}>
        
        {/* CABEÇALHO DESKTOP (Data, Saudação grande) */}
        <section className="gm-page-head hide-mobile">
          <div>
            <span className="gm-date-badge">{today}</span>
            <h1 className="gm-hero-h1">Olá, {firstName}.</h1>
            <p className="gm-hero-sub">Selecione uma área para continuar.</p>
          </div>
        </section>


        {/* ── SESSÃO OPERAÇÃO (Grid de Quadrados no Mobile) ── */}
        <section className="gm-section">
          <div className="gm-section-header">
            <h2>Operação</h2>
            <p className="hide-mobile">Vendas, lentes e compromissos.</p>
          </div>
          {/* O modificador "app-grid" aciona os cards quadrados no celular */}
          <div className="gm-card-grid app-grid">
            {quickCards.map((card) => (
              <HomeCard key={card.title} {...card} variant="square" />
            ))}
          </div>
        </section>

        {/* ── SESSÃO ADMINISTRAÇÃO (Grid de Listas no Mobile) ── */}
        {isAdmin && (
          <section className="gm-section">
            <div className="gm-section-header">
              <h2>Administração</h2>
              <p className="hide-mobile">Empresas, usuários e permissões.</p>
            </div>
            {/* O modificador "list-grid" aciona os cards horizontais no celular */}
            <div className="gm-card-grid list-grid">
              {adminCards.map((card) => (
                <HomeCard key={card.title} {...card} variant="list" />
              ))}
            </div>
          </section>
        )}
      </main>

      <footer className="gm-footer-home">
        <div className="gm-footer-inner">
          <span>© {new Date().getFullYear()} Lumix Óticas.</span>
          <strong>Lumix Óticas</strong>
        </div>
      </footer>
    </div>
  );
}

/* ── COMPONENTES MENORES ── */

function HomeCard({ title, description, href, icon, variant, featured }) {
  return (
    <a href={href} className={`gm-nav-card card-${variant} ${featured ? 'is-featured' : ''}`}>
      <div className="gm-card-icon">{icon}</div>
      <div className="gm-card-content">
        {featured && <span className="gm-card-badge">Mais usado</span>}
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
      <div className="gm-card-arrow"><Icons.ChevronRight /></div>
    </a>
  );
}

/* ==========================================
   CSS OTIMIZADO PARA GOOGLE MATERIAL / APP NATIVO
========================================== */

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

  :root {
    --bg: #ffffff;
    --sidebar-soft: #f1f1f1;
    --surface: #ffffff;
    --soft-bg: #f7f9f9;

    --line: #e8ecec;
    --line-strong: #d8dfde;

    --text: #172020;
    --text-2: #374642;
    --muted: #74807d;
    --soft: #9aa3a1;

    --accent: #36564c;
    --accent-soft: #eef4f2;

    --danger: #a63e36;
    --danger-soft: #fff6f5;

    --font: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  }

  *, *::before, *::after {
    box-sizing: border-box;
  }

  html,
  body {
    margin: 0;
    min-height: 100%;
    background: var(--bg);
    color: var(--text);
    font-family: var(--font);
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }

  body {
    overflow-x: hidden;
    transition: opacity .2s ease;
    -webkit-tap-highlight-color: transparent;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  button {
    font: inherit;
  }

  .hide-mobile {
    display: flex;
  }

  .show-mobile {
    display: none;
  }

  .gm-layout-home {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background: #fff;
  }

  /* =========================================================
     TOPBAR — MESMA LINGUAGEM DO SISTEMA
  ========================================================= */
  .gm-app-topbar {
    position: sticky;
    top: 0;
    z-index: 50;
    height: 60px;
    background: #fff;
    border-bottom: 1px solid var(--line);
    box-shadow: none;
  }

  .gm-topbar-inner {
    width: min(1240px, calc(100% - 40px));
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
  }

  .gm-brand {
    align-items: center;
    gap: 8px;
  }

  .gm-logo-wrapper {
    width: 28px;
    height: 28px;
    display: grid;
    place-items: center;
  }

  .gm-logo-wrapper img {
    width: 22px;
    height: 22px;
    object-fit: contain;
  }

  .gm-brand-text {
    color: var(--text);
    font-size: 15px;
    line-height: 1;
    font-weight: 800;
    letter-spacing: -.035em;
    white-space: nowrap;
  }

  .gm-topbar-actions {
    display: flex;
    align-items: center;
    gap: 9px;
  }

  .gm-user-meta {
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
  }

  .gm-user-meta strong {
    color: var(--text);
    font-size: 10.5px;
    line-height: 1.2;
    font-weight: 700;
  }

  .gm-user-meta span {
    margin-top: 2px;
    color: var(--muted);
    font-size: 8px;
    line-height: 1;
    font-weight: 650;
    text-transform: uppercase;
    letter-spacing: .05em;
  }

  .gm-avatar {
    width: 31px;
    height: 31px;
    display: grid;
    place-items: center;
    border: 1px solid var(--line-strong);
    border-radius: 50%;
    background: #fff;
    color: var(--text-2);
    font-size: 9px;
    font-weight: 800;
  }

  .gm-btn-logout {
    width: auto;
    height: 31px;
    padding: 0 8px;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    border: 1px solid var(--line);
    border-radius: 7px;
    background: #fff;
    color: var(--muted);
    cursor: pointer;
    font-size: 9px;
    font-weight: 700;
    box-shadow: none;
    transition: color .12s ease, border-color .12s ease, background .12s ease;
  }

  .gm-btn-logout:hover {
    color: var(--danger);
    border-color: #ead8d5;
    background: var(--danger-soft);
  }

  .gm-btn-logout svg {
    width: 13px;
    height: 13px;
  }

  /* =========================================================
     CONTEÚDO — SEM HERO CARD, SEM SOMBRA
  ========================================================= */
  .gm-main-content {
    width: min(1240px, calc(100% - 40px));
    margin: 0 auto;
    padding: 28px 0 42px;
    flex: 1;
    opacity: 0;
    transform: translateY(4px);
    transition: opacity .22s ease, transform .22s ease;
  }

  .gm-main-content.ready {
    opacity: 1;
    transform: none;
  }

  .gm-page-head {
    min-height: 105px;
    margin-bottom: 28px;
    padding: 4px 0 23px;
    align-items: flex-end;
    border-bottom: 1px solid var(--line);
    background: transparent;
  }

  .gm-date-badge {
    display: block;
    margin-bottom: 6px;
    color: var(--muted);
    font-size: 8.5px;
    line-height: 1;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .06em;
  }

  .gm-hero-h1 {
    margin: 0 0 4px;
    color: var(--text);
    font-size: 23px;
    line-height: 1.15;
    font-weight: 750;
    letter-spacing: -.035em;
  }

  .gm-hero-sub {
    margin: 0;
    color: var(--muted);
    font-size: 11px;
    line-height: 1.5;
    font-weight: 500;
  }

  /* =========================================================
     SEÇÕES
  ========================================================= */
  .gm-section {
    margin-bottom: 30px;
  }

  .gm-section-header {
    margin-bottom: 7px;
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 16px;
  }

  .gm-section-header h2 {
    margin: 0;
    color: var(--text);
    font-size: 12px;
    line-height: 1.3;
    font-weight: 750;
    letter-spacing: -.015em;
  }

  .gm-section-header p {
    margin: 0;
    color: var(--soft);
    font-size: 8.5px;
    line-height: 1.4;
    font-weight: 500;
  }

  /* =========================================================
     ATALHOS — FLAT, DIVIDIDOS APENAS POR LINHAS
  ========================================================= */
  .gm-card-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0,1fr));
    gap: 0;
    border-top: 1px solid var(--line);
    border-bottom: 1px solid var(--line);
    background: #fff;
  }

  .list-grid {
    grid-template-columns: repeat(2, minmax(0,1fr));
  }

  .gm-nav-card {
    position: relative;
    min-width: 0;
    min-height: 84px;
    padding: 13px 15px;
    display: grid;
    grid-template-columns: 31px minmax(0,1fr) 15px;
    align-items: center;
    gap: 10px;
    background: #fff;
    border: 0;
    border-right: 1px solid var(--line);
    border-radius: 0;
    box-shadow: none;
    transition: background .12s ease;
  }

  .gm-nav-card:last-child {
    border-right: 0;
  }

  .list-grid .gm-nav-card:nth-child(2) {
    border-right: 0;
  }

  .gm-nav-card:hover {
    background: var(--soft-bg);
    transform: none;
    box-shadow: none;
  }

  .gm-card-icon {
    width: 31px;
    height: 31px;
    display: grid;
    place-items: center;
    border: 0;
    border-radius: 0;
    background: transparent;
    color: var(--accent);
  }

  .gm-card-icon svg {
    width: 17px;
    height: 17px;
  }

  .gm-card-content {
    min-width: 0;
  }

  .gm-card-content h3 {
    margin: 0 0 3px;
    color: var(--text);
    font-size: 10.5px;
    line-height: 1.3;
    font-weight: 750;
  }

  .gm-card-content p {
    margin: 0;
    color: var(--muted);
    font-size: 8.5px;
    line-height: 1.45;
    font-weight: 500;
  }

  .gm-card-arrow {
    display: grid;
    place-items: center;
    color: #b7bfbd;
    transition: color .12s ease, transform .12s ease;
  }

  .gm-card-arrow svg {
    width: 14px;
    height: 14px;
  }

  .gm-nav-card:hover .gm-card-arrow {
    color: var(--accent);
    transform: translateX(1px);
  }

  .gm-card-badge {
    display: none;
  }

  /* =========================================================
     FOOTER
  ========================================================= */
  .gm-footer-home {
    width: min(1240px, calc(100% - 40px));
    margin: 0 auto;
    padding: 0 0 20px;
    color: var(--soft);
    font-size: 8.5px;
  }

  .gm-footer-inner {
    min-height: 40px;
    padding: 10px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    border: 0;
    border-top: 1px solid var(--line);
    border-radius: 0;
    background: #fff;
    box-shadow: none;
  }

  .gm-footer-inner strong {
    color: var(--muted);
    font-weight: 650;
  }

  /* =========================================================
     MOBILE — CONTINUA FLAT, SEM CARDS QUADRADOS
  ========================================================= */
  @media (max-width: 768px) {
    .hide-mobile {
      display: none !important;
    }

    .show-mobile {
      display: flex !important;
    }

    .gm-app-topbar {
      height: 58px;
      padding-top: env(safe-area-inset-top);
    }

    .gm-topbar-inner {
      width: 100%;
      padding: 0 12px;
    }

    .gm-mobile-brand-user {
      min-width: 0;
      align-items: center;
      gap: 8px;
    }

    .gm-mobile-brand {
      min-width: 0;
      display: flex;
      align-items: center;
      gap: 6px;
      flex-shrink: 0;
    }

    .gm-logo-mobile {
      width: 27px;
      height: 27px;
    }

    .gm-brand-text-mobile {
      font-size: 14px;
      letter-spacing: -.04em;
    }

    .gm-greeting-mobile {
      min-width: 0;
      padding-left: 8px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      border-left: 1px solid var(--line);
    }

    .gm-greeting-mobile span {
      color: var(--muted);
      font-size: 8px;
      line-height: 1.1;
      font-weight: 600;
    }

    .gm-greeting-mobile strong {
      max-width: 78px;
      overflow: hidden;
      color: var(--text);
      font-size: 11px;
      line-height: 1.2;
      font-weight: 750;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .gm-btn-logout {
      width: 31px;
      height: 31px;
      padding: 0;
      justify-content: center;
    }

    .gm-main-content {
      width: 100%;
      padding: 18px 12px 28px;
      opacity: 1;
      transform: none;
    }

    .gm-section {
      margin-bottom: 24px;
    }

    .gm-section-header {
      margin-bottom: 6px;
      display: block;
    }

    .gm-section-header h2 {
      font-size: 11.5px;
    }

    .gm-card-grid,
    .list-grid,
    .app-grid {
      grid-template-columns: 1fr !important;
      gap: 0 !important;
      border-top: 1px solid var(--line) !important;
      border-bottom: 1px solid var(--line) !important;
      border-left: 0 !important;
      border-right: 0 !important;
      border-radius: 0 !important;
      overflow: visible !important;
    }

    .gm-nav-card,
    .card-square,
    .card-list,
    .app-grid .gm-nav-card.is-featured {
      min-height: 68px !important;
      padding: 10px 4px !important;
      display: grid !important;
      grid-template-columns: 30px minmax(0,1fr) 15px !important;
      grid-template-rows: 1fr !important;
      align-items: center !important;
      gap: 9px !important;
      border: 0 !important;
      border-bottom: 1px solid var(--line) !important;
      border-radius: 0 !important;
      background: #fff !important;
      box-shadow: none !important;
    }

    .gm-nav-card:last-child,
    .card-square:last-child,
    .card-list:last-child {
      border-bottom: 0 !important;
    }

    .gm-nav-card:active {
      background: var(--soft-bg) !important;
      transform: none !important;
    }

    .card-square .gm-card-icon,
    .card-list .gm-card-icon,
    .gm-card-icon {
      width: 30px !important;
      height: 30px !important;
      grid-row: auto !important;
      background: transparent !important;
      border: 0 !important;
      border-radius: 0 !important;
    }

    .card-square .gm-card-content,
    .card-list .gm-card-content {
      grid-column: auto !important;
    }

    .card-square .gm-card-content h3,
    .card-list .gm-card-content h3,
    .gm-card-content h3 {
      margin-bottom: 2px !important;
      font-size: 10px !important;
    }

    .card-square .gm-card-content p,
    .card-list .gm-card-content p,
    .gm-card-content p {
      display: block !important;
      margin: 0 !important;
      font-size: 8px !important;
    }

    .card-square .gm-card-arrow,
    .card-list .gm-card-arrow,
    .app-grid .gm-nav-card.is-featured .gm-card-arrow {
      display: grid !important;
      margin-left: 0 !important;
    }

    .gm-footer-home {
      width: 100%;
      padding: 0 12px calc(14px + env(safe-area-inset-bottom));
    }

    .gm-footer-inner {
      align-items: flex-start;
      flex-direction: column;
      gap: 2px;
    }

    .gm-footer-inner span,
    .gm-footer-inner strong {
      font-size: 8px;
    }
  }

  @media (max-width: 390px) {
    .gm-brand-text-mobile {
      display: none;
    }

    .gm-greeting-mobile {
      padding-left: 0;
      border-left: 0;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: .01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: .01ms !important;
    }
  }
`;
